import { render, staticRenderFns } from "./StatsExtractEditeurs.vue?vue&type=template&id=3bc6c040&"
import script from "./StatsExtractEditeurs.vue?vue&type=script&lang=js&"
export * from "./StatsExtractEditeurs.vue?vue&type=script&lang=js&"
import style0 from "./StatsExtractEditeurs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports